import React, { useCallback } from 'react';
import { Alert, Box } from 'housecall-ui';

import { useOnlineBookingReducer } from '../state/useOnlineBookingReducer';

export const WarningMessage = () => {
  const {
    state: { warningMessage },
    dispatch,
    actions,
  } = useOnlineBookingReducer();

  const onClick = useCallback(() => dispatch(actions.hideWarningMessage()), [dispatch, actions]);

  if (!warningMessage) return null;

  return (
    <Box mb={2}>
      <Alert data-testid="ob-warning-message" severity="warning" onClose={onClick}>
        {warningMessage}
      </Alert>
    </Box>
  );
};
